// Package Imports
import { ScheduleOutlined } from '@ant-design/icons';

// Project Imports
import ModuleIdentifierConst from 'core/common/moduleIdentifier';
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const PayoutAdminResource: ResourceItem = {
  name: resourceName.payoutAdmin,
  identifier: ModuleIdentifierConst.PAYOUT_ADMIN,
  list: `${resourceName.payoutAdmin}`,
  show: `${resourceName.payoutAdmin}/show/:id`,
  meta: { label: 'Payout Admin', icon: <ScheduleOutlined /> },
};

export default PayoutAdminResource;
